
import XHeader from 'vux/src/components/x-header/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import TransferDomDirective from 'vux/src/directives/transfer-dom/index.js'

import auth from '@/modules/Auth'
import session from '@/modules/Session'

export default {
  components: {
    Group,
    Cell,
    XHeader,
    TransferDomDirective
  },
  methods: {
    displayName (user) {
      return `${user.data.local_name}  ${user.username}`
    },
    loginUser (userId) {
      this.$vux.loading.show({
        transition: '',
        text: '处理中...'
      })
      auth.login(userId, session.popProfileAuthToken()).then(
        this.$vux.loading.hide()
      )
    }
  },
  computed: {
    users () {
      return this.$store.state.profile.users
    },
    user () {
      return this.$store.state.user
    }
  },
  mounted () {
    if (this.user) {
      this.$router.push('/')
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ConfirmLogin.vue